import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import { ISettingsState } from '../types'
import * as actions from '../actions'

export default combineReducers<ISettingsState['communications']>({
  settings: makeCommunicationReducer(actions.loadSettings),
  getCurrenciesList: makeCommunicationReducer(actions.getCurrenciesList),
})
